import { StyleSheet } from 'react-native';




export const theme = {
  PRIMARY_FONT: {
    fontFamily: 'TrendSansFive',
    fontWeight: 300,
  },
  SECONDARY_FONT: {
    fontFamily: 'ProximaNova-Regular',
    fontWeight: 400,
  },
  TERTIARY_FONT: {
    fontFamily: 'ProximaNova-Semibold',
    fontWeight: 600,
  },
  
  FONT_XSMALL: {
    fontSize: 10,
    lineHeight: 16,
    letterSpacing: -0.2,
    fontWeight: 600
  },
  FONT_SMALL: {
    fontSize: 14,
    lineHeight: 21,
  },
  FONT_MEDIUM: {
    fontSize: 16,
    lineHeight: 24,
  },
  FONT_LARGE: {
    fontSize: 30,
    lineHeight: 30,
  },
  FONT_XLARGE: {
    fontSize: 35,
    lineHeight: 35,
  },
  FONT_XXLARGE: {
    fontSize: 48,
    lineHeight: 48,
  },

  COLORS: {
    WHITE: "#ffffff",
    BLACK: "#000000",

    BACKGROUND_COLOR: '#FBFBFB', // background color for main containers
    BACKGROUND_COLOR_CONTRAST: '#08254D',

    BACKGROUND_COLOR_SECONDARY: "#1B3D6D", // secondary background color (eg: footer)
    BACKGROUND_COLOR_SECONDARY_CONTRAST: "#FBFBFB",

    PRIMARY_COLOR: "#FBFBFB", // primary color
    PRIMARY_TEXT_COLOR: "#08254D", // primary text color

    SECONDARY_COLOR: "#176DAC", // secondary color
    SECONDARY_TEXT_COLOR: "#FFFFFF", // secondary text color

    ACCENT_COLOR: "#A5CE39",
    ACCENT_Text_COLOR: "#FFFFFF"
  },
};


export default StyleSheet.create({
  backText: {
    color: '#F6F3EA'
  },
  backIcon: {
    filter: "invert(1)",
    tintColor: theme.COLORS.WHITE,
  },

  widgetmainContainerHeaderSubTitle:{
    // display: 'none',
  },
  hotelListWidgetHeaderSubTitle: {
    display: "flex"
  },

  checkInGuideMainContainerHeaderImg: {
    marginTop: 0
  },

  infoModalTitle: {
    fontSize: 24
  },

  guestDetailsImageStyle: {
    display: "none"
  },


  mainContainerWidgetsContainer: {
    paddingBottom: 148
  },

  "locationIconContainer": {
    display: "none"
  },


  hotelListWidgetChildContainerTitle: {
    display: 'none',
  },
  hotelListWidgetChildContainer_items_container: {
    paddingTop: 0
  },
  hotelListWidgetChildContainer_itemContainer_highlight:{
    backgroundColor: theme.COLORS.BACKGROUND_COLOR,
  },

  hotelListWidgetChildContainer_1: {
    display: "none"
  },

  'infoWidgetsWidgetContainer': {
    paddingTop: 40,
  },
  
  'infoWidgetsWidgetContainer_info-heading-text':{
    alignItems: 'center',
    paddingTop: 43,
    paddingBottom: 0
  },
  'infoWidgetHeaderTitle_widget-group-heading': {
    fontWeight: 700,
    fontSize: 35,
    textAlignVertical: 'center',
    textTransform: 'uppercase',
    textAlign: 'left',
  },
  'infoWidgetHeaderTitle_info-heading-text': {
    // flexWrap: 'wrap',
    maxWidth: 250,
    alignSelf: 'center',
  },
  'infoWidgetHeaderSubtitle_info-heading-text': {
    paddingHorizontal: 0,
  },

  headerContainer: {
    backgroundColor: theme.COLORS.BACKGROUND_COLOR_SECONDARY,
  },
  mainContainerHeaderImg: {
    width: "100%",
    height: 262,
    maxWidth: 1000,
    margin: "auto",
  },
  notificationIcon: {
    filter: "invert(1)",
    tintColor: theme.COLORS.WHITE,
  },

  widgetmainContainerHeaderImg: {
    height: 262,
  },

  doorkeyGuideMainContainerHeaderSubTitle:{
    display: "flex"
  },

  

  primaryBtn: {
    height: 56,
    borderRadius: 5,
    paddingTop: 8,
    paddingRight: 32,
    paddingBottom: 8,
    paddingLeft: 32,
    gap: 8
  },
  tertiaryBtn: {
    height: 56,
    borderRadius: 5,
    paddingTop: 8,
    paddingRight: 32,
    paddingBottom: 8,
    paddingLeft: 32,
    gap: 8,
    backgroundColor: '#F8F8F8',
  },
  tertiaryBtnTxt: {
    color: theme.COLORS.PRIMARY_TEXT_COLOR
  },
  welcomeScreenContainer:{
    backgroundColor: 'black' // need to replaced with backgorund image
  },

  welcomeScreenContent: {
    paddingVertical: 0,
    paddingHorizontal: 16,
    justifyContent: "flex-end",
    backgroundColor: "transparent",
  },
  welcomeScreenLogoStyle: {
    width: 268.5112609863281,
    height: 72,
  },

  mainContainerHeaderContainer: {
    display: "none"
  },

  multipleLargeWidgetContainer: {
    paddingRight: 0,
  },
  multipleLargeWidgetTitleContainer: {
    paddingRight: 16
  },
  multipleLargeWidget_MainWidgetsContainer:{
    // alignItems: 'center',
    // flexShrink: 0,
    // flexGrow: 0,

  },
  multipleLargeWidget_WidgetsTitleContainer: {
    position: 'absolute',
    justifyContent: 'center',
    alignItems: 'center',
  },
  multipleLargeWidget_WidgetsTitleText: {
    // fontWeight: 700,
    fontSize: 30,
    letterSpacing: 0,
    textAlign: 'center',
    textAlignVertical: 'center',
    textTransform: 'uppercase',
    color: theme.COLORS.WHITE, 
  },
  multipleLargeWidget_WidgetsContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    width: null,
    borderRadius: 10,

    // width: 90,
    height: 130,
    gap: 8,
    padding: 5,    
  },
  multipleLargeWidgetTitleText: {
    color: theme.COLORS.PRIMARY_TEXT_COLOR,
  },
  multipleLargeWidgetViewAllTxt: {
    color: theme.COLORS.PRIMARY_TEXT_COLOR,
    bottom: 10
  },
  multipleLargeWidget_WidgetsImg: {
    objectFit: 'cover',
    position: 'relative',
    alignSelf: null,
    width: 258,
    height: 120,
    gap: 10,
    borderRadius: 10
  },


  guestItineraryWidgetTitleText: {
    ...theme.PRIMARY_FONT,
    ...theme.FONT_LARGE,
    textTransform: "uppercase"
  },
  guestItineraryWidgetTitleArrow_container: {
    display: "none"
  },



  multipleSmallWidgetContainer: {
    backgroundColor: theme.COLORS.PRIMARY_COLOR,
    color: theme.COLORS.PRIMARY_TEXT_COLOR,
    paddingRight: 0
  },
  multipleSmallWidgetTitleContainer: {
    paddingRight: 16
  },
  multipleSmallWidget_WidgetsContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 10,

    width: 90,
    height: 130,
    gap: 8,
    padding: 5,    
  },
  multipleSmallWidgetTitleTextContainer:{
    maxWidth: '86%',
  },
  multipleSmallWidgetTitleText: {
    color: theme.COLORS.PRIMARY_TEXT_COLOR,
    width: '100%',
  },
  multipleSmallWidgetViewAllTxt: {
    color: theme.COLORS.PRIMARY_TEXT_COLOR,
    bottom: 10
  },
  multipleSmallWidget_WidgetsImg: {
    objectFit: 'cover',
    width: 80,
    height: 80,
    gap: 10,
    borderRadius: 10,
    position: 'relative'
  },
  multipleSmallWidget_WidgetsTitleText: {
    ...theme.PRIMARY_FONT,
    textAlignVertical: 'center',
    textTransform: 'uppercase',

    fontWeight: 600,
    fontSize: 13,
    lineHeight: 16,
    letterSpacing: 0,
    textAlign: 'center',
    color: '#111111',
    width: '100%',
    height: 32,
  },
  multipleSmallWidget_WidgetsTitleContainer: {
    padding: 0
  },
  multipleSmallWidget_MainWidgetsContainer: {
    gap: 10
  },

  "infoWidgetImageStyle_info-heading-text": {
    display: 'none'
  },

// Easter Weekends
  "infoPageScrollWidgetButtonContainerText_info-full-image": {
    ...theme.TERTIARY_FONT,
    fontSize: 22,
  },


  hotelListWidgetHeaderTitleContainer: {
    paddingBottom: 0,
  },




  "infoWidgetsWidgetContainer_info-heading-logo": {
    paddingHorizontal: 40,
    marginBottom: 20,
    height: "auto",
    maxHeight: 230,
    overflow: "hidden",
    alignItems: "center",
    paddingTop: 10,
  },
  "infoWidgetImageStyle_info-heading-logo": {
    maxHeight: "100%",
    width: "100%",
    height: 98,
    resizeMode: "contain",
    maxWidth: 300
  },



  // Experiences Screen
  subwidgetListMainContainerChildContainer: {
    // display: 'flex',
    flexDirection: 'column',
    // flexWrap: 'wrap',
    // justifyContent: 'space-between',
    // flex: 'unset',
  },
  'subwidgetListMainContainerChildContainer_experience-widget-item':{
    flex: null,
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
    // paddingRight: 8,
    // paddingLeft: 16
    gap: 16,
  },
  'subwidgetList_itemContainer_experience-widget-item':{
    flex: 1,
    padding: 0,
    maxWidth: 170,
    // height: "100%",
    paddingVertical: 0,
    marginBottom: null,
    // marginRight: 8,
    // maxWidth: 170,
    borderBottomWidth: null,
    borderBottomColor: null,
  },
  'subwidgetList_itemContainer_textContainer_experience-widget-item':{
    bottom: -25,
  },
  'subwidgetList_itemContainer_image_experience-widget-item':{
    borderRadius: 10,
  },
  'subwidgetList_itemContainer_textContainer_title_experience-widget-item':{
    // ...theme.SECONDARY_FONT,
    // // fontWeight: 600,
    // fontSize: 18,
    display: 'none'
  },




  subwidgetList_itemContainer: {
    gap: null,
    width: '100%',
    height: 120,
    marginBottom: 16,
  },
  subwidgetList_itemContainer_image: {
    width: '100%',
    height: 120,
    borderRadius: 10,
    objectFit: 'cover',
    boxSizing: 'border-box'
  },
  subwidgetList_itemContainer_textContainer: {
    position: 'absolute',
    width: '100%'
  },
  subwidgetList_itemContainer_textContainer_title: {
    ...theme.PRIMARY_FONT,
    ...theme.FONT_LARGE,
    lineHeight: 35,
    // fontWeight: 700,
    fontSize: 35,
    textAlign: 'center',
    textAlignVertical: 'center',
    textTransform: 'uppercase',
    color: theme.COLORS.WHITE
  },
  subwidgetList_itemContainer_arrow: {
    display: 'none'
  },

  bannerWidgetImage: {
    width: '100%',
    height: '100%',
    // objectFit: 'cover',
  },

  'bannerWidgetTitle': {
    ...theme.TERTIARY_FONT,
  },

  'bannerWidgetsWidgetContainer_widget-long-banner':{
    // paddingTop: 10,
    // paddingBottom: 10,
    marginBottom: 20
  },
  'bannerWidgetImageStyle_widget-long-banner': {
      position: 'absolute',
      width: '100%',
      height: 105,
  },
  'bannerWidgetImage_widget-long-banner':{
    borderRadius: 10,
  },
  'bannerWidgetTextContainer_widget-long-banner': {
    flex: null,
    width: '100%',
  },
  'bannerWidgetTitle_widget-long-banner': {
    ...theme.TERTIARY_FONT,
    ...theme.FONT_XLARGE,
    // fontWeight: 700,
    letterSpacing: 0,
    textAlign: 'center',
    textTransform: 'uppercase',

    color: theme.COLORS.WHITE
  },
  'bannerWidgetArrow_container_widget-long-banner': {
    display: "none"
  },

  guestItineraryWidgetMainContainer: {
    // marginTop: 90,
  },
  bannerWidgetsWidgetContainer_25:{
    position: 'absolute',
    top: -50,
    borderRadius: 5,
    padding: 16,
    
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.08,
    shadowRadius: 6,
    elevation: 4, 
  },

  "bannerWidgetMainContainer_guest-details-login":{
    top: -50,
    width: "100%",
    zIndex: 100,
    marginBottom: -50,
  },
  "bannerWidgetsWidgetContainer_guest-details-login":{
    padding: 16,
    borderWidth: 1,
    borderColor: '#0000001A',
    borderRadius: 5,

    // iOS shadow
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.08,
    shadowRadius: 6,
  },

  "infoWidgetHeaderTitle_widget_19": {
    textAlign: 'left',
    ...theme.FONT_XLARGE
  },

  "infoWidgetHeaderTitle_info-widget-mystay": {
    textAlign: "left",
    ...theme.FONT_LARGE,
  },

  bannerWidgetDescription: {
    textTransform: null
  },

  doorkeyMainContainerHeaderSubTitle: {
    ...theme.FONT_SMALL,
    fontWeight: 400
  },
  doorkeyMainContainerHeaderSubTitleCaption: {
    ...theme.FONT_MEDIUM,
    fontWeight: 600
  },
  doorKeyOrText: {
    ...theme.PRIMARY_FONT,
    ...theme.FONT_LARGE,
    fontWeight: 700,
    color: theme.COLORS.BACKGROUND_COLOR_CONTRAST
  },
  secondaryBtn: {
    borderRadius: 5
  },
  doorkeyMainContainerChildContainer: {
    paddingLeft: 0,
    paddingRight: 0
  },
  doorKeyButton: {
    width: "100%",
    backgroundColor: theme.COLORS.SECONDARY_COLOR,
  },

  promoWidgetImage:{
    height: 262
  },


  // Dining Screen
  "subwidgetList_itemContainer_image_dine-panels":{
    width: 130,
    height: 130,
    objectFit: "cover",
  },
  "subwidgetList_itemContainer_textContainer_dine-panels": {
    flex: 1,
    height: "100%",
    justifyContent: "flex-start",
    position: "relative",
    gap: 8,
    paddingTop: 10,
  },
  "subwidgetList_itemContainer_textContainer_title_dine-panels": {
    ...theme.SECONDARY_FONT,
    fontSize: 20,
    fontWeight: 600,
    color: theme.COLORS.BLACK,
    lineHeight: null,
    textAlign: "start",
    paddingBottom: 5,
    width: "100%"
  },
  "subwidgetListImageStyle_dine-panels":{
    width: 130,
    height: 130,
  },
  "subwidgetList_itemContainer_dine-panels": {
    gap: 16,
    height: "100%",
    maxHeight: 146,
    marginBottom: 0,
  },
  "subwidgetList_itemContainer_textContainer_subtitle_dine-panels":{
    color: theme.COLORS.BLACK,
    textTransform: "normal",
  },


  "multipleLargeWidgetTitleText_dine-panels": {
    color: theme.COLORS.WHITE,
    lineHeight: null,
    maxWidth: null,
    height: "100%",
    width: "100%",
    alignItems: "center",
    justifyContent: "center"
  },
  "subwidgetList_itemContainer_image_dine-panels-reverse":{
    width: 130,
    height: 105,
    objectFit: "cover",
  },
  "subwidgetList_itemContainer_textContainer_dine-panels-reverse": {
    flex: 1,
    height: "100%",
    justifyContent: "flex-start",
    position: "relative",
    gap: 8,
    paddingTop: 10,
  },
  "subwidgetList_itemContainer_textContainer_title_dine-panels-reverse": {
    ...theme.SECONDARY_FONT,
    fontSize: 20,
    fontWeight: 600,
    width: "100%",
    color: theme.COLORS.BLACK,
    lineHeight: null,
    textAlign: "start",
    paddingBottom: 5,
  },
  "subwidgetListImageStyle_dine-panels-reverse":{
    width: 130,
    height: 105,
  },
  "subwidgetList_itemContainer_dine-panels-reverse": {
    gap: 16,
    height: "100%",
    maxHeight: 146,
    flexDirection: "row-reverse",
    marginBottom: 0,
  },
  "subwidgetList_itemContainer_textContainer_subtitle_dine-panels-reverse":{
    color: theme.COLORS.BLACK,
    textTransform: "normal",
  },
  
  "multipleLargeWidgetTextContainer_dine-panels":{
    maxWidth: "100%",
    height: "100%",
    width: "100%",
  },

  "multipleLargeWidgetViewAll_dine-panels":{
    position: "absolute",
    width: "100%",
    zIndex: 100,
    height: "100%",
    // maxHeight: 105,
    justifyContent: "center",
    alignItems: "center",
    bottom: 0
  },
  "multipleLargeWidgetViewAllTxt_dine-panels": {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: "100%",
    textAlign: "center",
    opacity: 0,
    bottom: 0
  },

  "multipleLargeWidgetContainer_dine-panels": {
    paddingRight: 16,
    paddingTop: 10,
    paddingBottom: 10,
    maxHeight: 120
  },
  "multipleLargeWidget_MainWidgetsContainer_dine-panels": {
    display: "none"
  },
  "multipleLargeWidgetTitleContainer_dine-panels": {
    height: 105,
    paddingRight: 0,

  },
  multipleLargeWidgetImageContainer: {
    position: "absolute",
    zIndex: -1,
    width: "100%"
  },
  multipleLargeWidgetImage:{
    height: 105,
    width: "100%",
    borderRadius: 10,
    objectFit: "cover",
  },  
  
  subwidgetListMainContainerImage:{
    height: 262,
    objectFit: "cover",
    width: "100%"
  },   

  "infoPageScrollWidgetButtonContainerText_promo-scroller":{
    color: theme.COLORS.SECONDARY_TEXT_COLOR,
    ...theme.TERTIARY_FONT,
    fontSize: 22,
  },


  welcomeScreenBottomLoginContainer: {
    display: "none"
  },
  multipleSmallWidgetDescriptionText:{
    display: "none"
  },
  multipleLargeWidgetDescriptionText:{
    display: "none"
  },

  "subwidgetList_itemContainer_widget-long-banner": {
    paddingVertical: 0,
  }
  
});

